import React, { useState } from 'react';
import './Egg.css';
import { shallowEqual, useSelector } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';
import Practice from '../../../Unit3/Module13/Practice';
import PracticeSituation from '../../Practice/PracticeSituation';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function EggPractice(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [eggs, setEggs] = useState(false);
  const [egg1, setEgg1] = useState(true);
  const [egg2, setEgg2] = useState(false);
  const [egg3, setEgg3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [practice, setPractice] = useState('');
  const [displayReview, setDisplayReview] = useState(false);
  const [openPractice, setOpenPractice] = useState(false);
  const [eggScene, setEggScene] = useState(true);
  const [displayLearnVideo, setDisplayLearnVideo] = useState(true);
  const [learnVideo, setlearnVideo] = useState(props.video1);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const egg1Img = generateImageUrl('images/Module18Images/Egg+1.svg');
  const egg2Img = generateImageUrl('images/Module18Images/Egg+2.svg');
  const egg3Img = generateImageUrl('images/Module18Images/Egg+3.svg');
  const nestImg = generateImageUrl('images/Module18Images/Nest.svg');
  const optionTakeBreaths = {
      img: generateImageUrl('images/Module18Images/practice/Take deep breaths.png'),
      title: 'Take deep breaths',
      audioPrompt: 'appfiles/resolve_conflict/option_take_breaths.mp3',
  };
  const optionYell = {
      img: generateImageUrl('images/Module18Images/practice/yell.png'),
      title: 'Yell',
      audioPrompt: 'appfiles/resolve_conflict/option_yell.mp3',
  };
  const optionHit = {
      img: generateImageUrl('images/Module18Images/practice/hit.png'),
      title: 'Hit',
      audioPrompt: 'appfiles/resolve_conflict/option_hit.mp3',
  };
  const optionCalmVoice = {
      img: generateImageUrl('images/Module18Images/practice/calm voice.png'),
      title: 'Calm Voice',
      audioPrompt: 'appfiles/resolve_conflict/option_calm_voice.mp3',
  };
  const optionWhipser = {
      img: generateImageUrl('images/Module18Images/practice/whisper.png'),
      title: 'Whipser',
      audioPrompt: 'appfiles/manners/option_whisper.mp3',
  };
  const optionLoudVoice = {
      img: generateImageUrl('images/Module18Images/practice/loud voice.png'),
      title: 'Loud voice',
      audioPrompt: 'appfiles/resolve_conflict/option_loud_voice.mp3',
  };
  const optionCalmHands = {
      img: generateImageUrl('images/Module18Images/practice/calm hands.png'),
      title: 'Use calm hands',
      audioPrompt: 'appfiles/resolve_conflict/option_calm_hands.mp3',
  };
  const optionFeelSad = {
      img: generateImageUrl('images/Module18Images/practice/I feel sad.png'),
      title: 'I feel sad',
      audioPrompt: 'appfiles/resolve_conflict/option_feel_sad.mp3',
  };
  const optionNotLikeYou = {
      img: generateImageUrl('images/Module18Images/practice/I do not like you.png'),
      title: 'I do not like you',
      audioPrompt: 'appfiles/resolve_conflict/option_not_like_you.mp3',
  };
  const optionMadeFeelSad = {
      img: generateImageUrl('images/Module18Images/practice/You made me feel sad.png'),
      title: 'You made me feel sad',
      audioPrompt: 'appfiles/resolve_conflict/option_made_feel_sad.mp3',
  };
  const optionHowFeel = {
      img: generateImageUrl('images/Module18Images/practice/how do you feel.png'),
      title: 'How do you feel?',
      audioPrompt: 'appfiles/resolve_conflict/option_how_feel.mp3',
  };
  const optionUseLoudVoice = {
      img: generateImageUrl('images/Module18Images/practice/use your loud voice.png'),
      title: 'Use your loud voice',
      audioPrompt: 'appfiles/resolve_conflict/option_use_loud_voice.mp3',
  };
  const optionListen = {
      img: generateImageUrl('images/Module18Images/practice/listen.png'),
      title: 'Listen',
      audioPrompt: 'appfiles/resolve_conflict/option_listen.mp3',
  };
  const optionIgnore = {
      img: generateImageUrl('images/Module18Images/practice/ignore them.png'),
      title: 'Ignore them',
      audioPrompt: 'appfiles/resolve_conflict/option_ignore.mp3',
  };
  const optionSorry = {
      img: generateImageUrl('images/Module18Images/practice/I am sorry.png'),
      title: 'I am sorry',
      audioPrompt: 'appfiles/manners/option_sorry.mp3',
  };
  const optionExcuseMe = {
      img: generateImageUrl('images/Module18Images/practice/excuse me.png'),
      title: 'Excuse me',
      audioPrompt: 'appfiles/manners/option_excuse_me.mp3',
  };
  const optionThankYou = {
      img: generateImageUrl('images/Module18Images/practice/Thank you.png'),
      title: 'Thank you',
      audioPrompt: 'appfiles/manners/option_thank_you.mp3',
  };
  const optionGiveUp = {
      img: generateImageUrl('images/Module18Images/practice/just give up.png'),
      title: 'Just give up',
      audioPrompt: 'appfiles/resolve_conflict/option_give_up.mp3',
  };
  const optionNoBeFriend = {
      img: generateImageUrl('images/Module18Images/practice/not be their friend.png'),
      title: 'Not be their friend',
      audioPrompt: 'appfiles/resolve_conflict/option_no_be_friend.mp3',
  };
  const optionSayNice = {
      img: generateImageUrl('images/Module18Images/practice/say something nice.png'),
      title: 'Say something nice',
      audioPrompt: 'appfiles/resolve_conflict/option_say_nice.mp3',
  };
  const optionBeFriend = {
      img: generateImageUrl('images/Module18Images/practice/be a good friend.png'),
      title: 'Be a good friend',
      audioPrompt: 'appfiles/resolve_conflict/option_be_friend.mp3',
  };

  // Scenarios
  const scenarioUnkind = {
    prompt:
      'If you feel mad because someone said something unkind to you, you should',
    audioPrompt: 'appfiles/resolve_conflict/scenario_unkind.mp3',
    correctMatch: optionTakeBreaths,
    incorrectMatches: [optionYell, optionHit],
  };

  const scenarioTalkFeelings = {
    prompt:
      'If you are ready to talk to your friend about your feelings, you should talk in a',
    audioPrompt: 'appfiles/resolve_conflict/scenario_talk_feelings.mp3',
    correctMatch: optionCalmVoice,
    incorrectMatches: [optionWhipser, optionLoudVoice],
  };

  const scenarioFeelMad = {
    prompt:
      'Even if you feel mad and want to hit, you should take deep breaths, use a calm voice and',
    audioPrompt: 'appfiles/resolve_conflict/scenario_feel_mad.mp3',
    correctMatch: optionCalmHands,
    incorrectMatches: [optionYell, optionHit],
  };

  const scenarioTellFeelSad = {
    prompt:
      'If you want to tell a friend that you felt sad when you two did not get along, you should say',
    audioPrompt: 'appfiles/resolve_conflict/scenario_tell_feel_sad.mp3',
    correctMatch: optionFeelSad,
    incorrectMatches: [optionNotLikeYou, optionMadeFeelSad],
  };

  const scenarioAskFeelSad = {
    prompt:
      'If you want to know how your friend felt when you two did not get along, you should ask',
    audioPrompt: 'appfiles/resolve_conflict/scenario_ask_feel_sad.mp3',
    correctMatch: optionHowFeel,
    incorrectMatches: [optionNotLikeYou, optionMadeFeelSad],
  };

  const scenarioListenFeelings = {
    prompt: 'After you ask your friend how they feel, you should',
    audioPrompt: 'appfiles/resolve_conflict/scenario_listen_feelings.mp3',
    correctMatch: optionListen,
    incorrectMatches: [optionUseLoudVoice, optionIgnore],
  };

  const scenarioBeAccountable = {
    prompt: 'If you said something not nice to your friend, you should say',
    audioPrompt: 'appfiles/resolve_conflict/scenario_be_accountable.mp3',
    correctMatch: optionSorry,
    incorrectMatches: [optionExcuseMe, optionThankYou],
  };

  const scenarioMakeBetter = {
    prompt: 'After you say sorry, you can',
    audioPrompt: 'appfiles/resolve_conflict/scenario_make_better.mp3',
    correctMatch: optionSayNice,
    incorrectMatches: [optionGiveUp, optionNoBeFriend],
  };

  const scenarioBetterNext = {
    prompt: 'Now that you have made it better, you can',
    audioPrompt: 'appfiles/resolve_conflict/scenario_better_next.mp3',
    correctMatch: optionBeFriend,
    incorrectMatches: [optionGiveUp, optionNoBeFriend],
  };

  const titles = [
    ['Calm Down', 'Calm Voice', 'Calm Hands'],
    ['Share', 'Ask', 'Listen'],
    ['Be Accountable', 'Make it better', 'Be better next time'],
  ];
  const options = [
    [scenarioUnkind, scenarioTalkFeelings, scenarioFeelMad],
    [scenarioTellFeelSad, scenarioAskFeelSad, scenarioListenFeelings],
    [scenarioBeAccountable, scenarioMakeBetter, scenarioBetterNext],
  ];
  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );
  // CSS code for the back button


  const displayPractice = (num) => {
    setPractice(
      <PracticeSituation
        options={[options[props.module.currentday - 1][num - 1]]}
        title={titles[props.module.currentday - 1][num - 1]}
        setDisplayPractice={setOpenPractice}
        background={props.background}
        stepComplete={''}
        module={props.module}
        next={() => {
          if (num === 1) {
            setEffect1('');
            setEffect2('bounceIcons');
            setEgg2(true);
            sleep(700).then(() => {
              bounceSound.play()
            });
          } else if (num === 2) {
            setEffect2('');
            setEffect3('bounceIcons');
            setEgg3(true);
            sleep(700).then(() => {
              bounceSound.play()
            });
          } else if (num === 3) {
            setDisplayReview(true);
            setEggScene(false);
            setOpenPractice(false);
          }
        }}
      />
    );
    setOpenPractice(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      {openPractice && practice}
      {eggScene && !openPractice && (
        <div
          className='eggScene'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          {displayLearnVideo && (
            <CloudfrontVideoFormat
              source={learnVideo}
              back={'unit4'}
              background={props.background}
              close={props.setDisplayPractice}
              ended={() => {
                setDisplayLearnVideo(false);
                setEggs(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              }}
            />
          )}
          {eggs && (
            <div className='lizard_Egg'>
              <div className='egg_nest'>
                {<img alt='' className='nestEgg' src={nestImg} />}
                {egg1 && (
                  <div
                    className='egg1'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        displayPractice(1);
                      });
                    }}
                  >
                    <img alt='' id={effect1} src={egg1Img} />
                  </div>
                )}
                {egg2 && (
                  <div
                    className='egg2'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        displayPractice(2);
                      });
                    }}
                  >
                    <img alt='' className='egg2' id={effect2} src={egg2Img} />
                  </div>
                )}
                {egg3 && (
                  <div
                    className='egg3'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        displayPractice(3);
                      });
                    }}
                  >
                    <img alt='' className='egg3' id={effect3} src={egg3Img} />
                  </div>
                )}
              </div>
              {<img alt='' className='animateLizard' src={props.animal} />}
            </div>
          )}
        </div>
      )}
      {displayReview && (
        <Practice
          reviewVideo={props.video2}
          setDisplayPractice={props.setDisplayPractice}
          background={props.background}
          stepComplete={'MODULE18_SET_stepCompleted'}
          module={props.module}
          unit4={true}
        />
      )}
    </>
  );
}
